<template>
  <div class="body" :style="backgroundDiv">
    <div class="center">
      <span class="title">Dealer Payment System</span>
      <div class="login-from">
        <div class="left">
          <img :src="pop" style="width:100%;height:100%"/>
        </div>
        <div class="right">
          <div class="top" style="margin-top:13.52%">
            <img :src="logo"/>
          </div>
          <div class="right-body">
            <div class="body-span">
              <p>代理店番号</p>
              <el-input
                class="input"
                placeholder="ログインID"
                v-model="username"
                clearable
                @focus="userfocus(1)"
                @blur="userfocus(0)"
                >
                <i slot="prefix"><img :src="user" v-if="this.isuserfocus==0" class="img"/><img :src="user2" v-else class="img"/></i>
              </el-input>
            </div>
            <div class="body-span">
              <p>パスワード</p>
              <el-input class="input" placeholder="ログインパスワード" v-model="password" @focus="passfocus(1)" @blur="passfocus(0)" show-password><i slot="prefix"><img  v-if="this.ispassfocus==0" :src="pass" class="img"/><img  v-else :src="pass2" class="img"/></i></el-input>
            </div>
            <el-button class="ri-btn" @click="login()">ログイン</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { bg , logo , pop , user , user2 , pass , pass2 } from '../../images/agentLogin/index'
export default {
  data () {
    return {
      bg,
      logo,
      pop,
      user,
      user2,
      pass,
      pass2,
      isuserfocus: 0,
      ispassfocus: 0,
      backgroundDiv: {
        backgroundImage: 'url(' + require('../../images/agentLogin/bg.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      },
      username: '',
      password: '',
    }
  },
  methods: {
    userfocus(i){
      this.isuserfocus = i
    },
    passfocus(i){
      this.ispassfocus = i
    },
    login(){
      var _this = this
      let data = {
        username: this.username,
        pwd: this.password
      }
      this.$axios({
         method:'post',
         url:'http://mbcrm.kaitekitv.com:8080/visitor/user/agentaccount/login',//http://192.168.3.32:8086/forcecms_zhongyin/ //http://203.85.72.1/forcecms_zhongyin20180515/
         headers: {
           'Content-Type': 'application/json',//设置请求头请求格式为JSON
         },
         params:data
      }).then((res)=>{
        console.log(res.data.user)
        this.$store.commit('SET_login',true);
        this.$store.commit('set_username',res.data.user.accountname)
        this.$router.push({path: "/agentbuy"});
      })
    }
  }
}
</script>
<style scoped>
  .body{
    width: 100vw;
    height: 100vh;
  }
  .center{
    width: 47.79%;
    height: 57.41%;
    margin: 0 auto;
    margin-top: 11vh;
    text-align: center;
  }
  .title{
    font-size: 36px;
    font-family: ITC Avant Garde Gothic Std;
    font-weight: bold;
    color: #FFFFFF;
  }
  .login-from{
    margin-top: 2.5vh;
    width: 100%;
    height: 90%;
  }
  .left{
    float: left;
    width: 50%;
    height: 100%;
  }
  .right{
    float: left;
    background-color: #FFFFFF;
    width: 50%;
    height: 100%;
    border-top-right-radius: 6px;
    border-bottom-right-radius:6px;
  }
  .right-body{
    width: 70%;
    margin: 0 auto;
    margin-top: 50px;
  }
  .right-body p{
    font-size: 18px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #8F8F8F;
    line-height: 27px;
    margin-bottom: 5px;
  }
  .right-body .input{
    margin-bottom: 15px;
  }
  .body-span{
    text-align: left;
  }
  .img{
    margin-top: 5px;
  }
  .ri-btn{
    margin-top: 20px;
    width: 100%;
    height: 50px;
    background: #39D8CC;
    border-radius: 6px;   
    font-size: 22px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #000000;
  }
</style>


// WEBPACK FOOTER //
// src/components/agentLogin/index.vue